import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import Joi from "joi-browser";
import { getTotalHours } from "../../services/appService";
import { getAlert, getConfirmAlert } from "../../services/appAlerts";
import Input from "../../comman/input";
import TextArea from "../../comman/textarea";
import { updateCandidateInvoiceReview } from "../../app/store/candidate";

const schema = {
  name: Joi.string(),
  description: Joi.string(),
};

function InvoiceReview(props) {
  const {
    selectedObj,
    invType,
    timeLogInvoices,
    candidateObj,
    getInvoiceAmount,
    entType,
    invRevShowHide,
    handleInvRevShowHide,
  } = props;

  const [data, setData] = useState({});
  const [errors, setErrors] = useState({});
  const [isProcessing, setIsProcessing] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (selectedObj !== undefined && selectedObj !== "") {
      const obj = selectedObj;
      const nextData = {};
      nextData["status"] = "";
      nextData["reason"] = "";
      nextData["adjustmentPlus"] = "";
      nextData["adjustmentMinues"] = "";

      let candidateRate = 0;
      let invoType = invType;
      if (invType === "subcontractor") {
        if (entType === "C2C Basis" && candidateObj?.rates?.subcontractorRate) {
          candidateRate = candidateObj.rates.subcontractorRate;
        } else {
          if (candidateObj?.rates?.candidateRate)
            candidateRate = candidateObj.rates.candidateRate;

          invoType = "candidate";
        }
      }

      if (invType === "recruiter" && candidateObj.rates?.recruiterRate)
        candidateRate = candidateObj.rates.recruiterRate;
      if (invType === "agency" && candidateObj.rates?.agencyRate)
        candidateRate = candidateObj.rates.agencyRate;

      let fAmt = 0;
      if (invType === "subcontractor") {
        fAmt = parseFloat(getInvoiceAmount(obj));
      } else {
        fAmt = parseFloat(getTotalHours(obj?.workingHrs) * candidateRate);
      }
      let baselineAmt = fAmt;
      const invItems = timeLogInvoices.filter((x) => x.timeLogId === obj.id);

      if (invItems.length > 0) {
        const selectedInv = invItems[0];
        if (selectedInv?.adpDeduction > 0) {
          baselineAmt += selectedInv.adpDeduction;
          fAmt += selectedInv.adpDeduction;
        }

        if (selectedInv?.adjustmentMinues > 0)
          fAmt -= selectedInv.adjustmentMinues;
        if (selectedInv?.adjustmentPlus > 0) fAmt += selectedInv.adjustmentPlus;

        nextData["status"] = selectedInv.status;
        nextData["reason"] = selectedInv.reason;
        nextData["adjustmentPlus"] =
          selectedInv.adjustmentPlus?.toString() ?? "";
        nextData["adjustmentMinues"] =
          selectedInv.adjustmentMinues?.toString() ?? "";
      }
      nextData["id"] = obj.id;
      nextData["finalAmt"] = parseFloat(fAmt).toFixed(2);
      nextData["docUploadType"] = invoType;
      nextData["rate"] = candidateRate;
      nextData["baselineAmt"] = baselineAmt;
      setData(nextData);
      setErrors({});
    } else {
      setData({});
      setErrors({});
    }
  }, [
    selectedObj,
    invType,
    timeLogInvoices,
    candidateObj,
    getInvoiceAmount,
    entType,
  ]);

  const validateProperty = ({ name, value }) => {
    const obj = { [name]: value };
    if (schema[name] === undefined) return null;
    const fieldSchema = { [name]: schema[name] };
    const { error } = Joi.validate(obj, fieldSchema);
    return error ? error.details[0].message : null;
  };

  const validate = () => {
    const options = { abortEarly: false, allowUnknown: true };
    const result = Joi.validate(data, schema, options);
    if (!result.error) return null;
    const validationErrors = {};
    for (let item of result.error.details) {
      if (item.type === "any.required")
        validationErrors[item.path[0]] = item.message;
    }
    if (Object.keys(validationErrors).length > 0) return validationErrors;
    return null;
  };

  const handleChange = ({ currentTarget: input }) => {
    const nextErrors = { ...errors };
    const errorMessage = validateProperty(input);
    if (errorMessage) nextErrors[input.name] = errorMessage;
    else delete nextErrors[input.name];

    const nextData = { ...data };
    nextData[input.name] = input.value;

    if (input.name === "adjustmentPlus" || input.name === "adjustmentMinues") {
      const baseline = parseFloat(nextData.baselineAmt) || 0;
      const plus = parseFloat(nextData.adjustmentPlus) || 0;
      const minus = parseFloat(nextData.adjustmentMinues) || 0;
      nextData["finalAmt"] = parseFloat(baseline + plus - minus).toFixed(2);
    }

    setData(nextData);
    setErrors(nextErrors);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isProcessing) return;
    const formErrors = validate();
    setErrors(formErrors || {});
    if (formErrors) return;

    const result = await getConfirmAlert(
      "Warning",
      "Are you sure you want to save Timelog?",
      "warning",
    );
    if (result.isConfirmed) {
      setIsProcessing(true);
      try {
        await dispatch(updateCandidateInvoiceReview(data));
        handleInvRevShowHide("save");
        getAlert("Timelog Saved Successfully", "", "success");
      } finally {
        setIsProcessing(false);
      }
    }
  };

  const renderInput = (name, label, type = "text") => (
    <Input
      type={type}
      name={name}
      value={data[name] || ""}
      label={label}
      onChange={handleChange}
      error={errors[name]}
      req={schema[name]}
    />
  );

  const renderTextArea = (name, label) => (
    <TextArea
      name={name}
      value={data[name] || ""}
      label={label}
      onChange={handleChange}
      error={errors[name]}
      req={schema[name]}
    />
  );

  return (
    <>
      <style
        dangerouslySetInnerHTML={{
          __html: `
        .modal-backdrop { z-index: 1080 !important; }
        .modal { z-index: 1090 !important; }
        .modal-backdrop.show { backdrop-filter: blur(8px) !important; -webkit-backdrop-filter: blur(8px) !important; background-color: rgba(15, 23, 42, 0.45) !important; opacity: 1 !important; }
        .modal.fade .wf-review-modal.modal-dialog { transform: scale(0.95) !important; transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) !important; }
        .modal.show .wf-review-modal.modal-dialog { transform: scale(1) !important; }
        .wf-review-modal { --task-accent: #2563eb; --task-soft: #f8fafc; max-width: 760px !important; width: 100% !important; }
        .wf-review-modal .modal-content { border-radius: 16px !important; border: none !important; box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important; overflow: hidden !important; background: #ffffff !important; }
        .wf-review-modal .modal-header { position: relative !important; display: block !important; padding: 22px 28px 18px 32px !important; background: linear-gradient(90deg, var(--task-soft) 0%, rgba(255,255,255,0.98) 54%, #ffffff 100%) !important; border-bottom: 1px solid #edf2f7 !important; overflow: hidden !important; }
        .wf-review-modal .modal-header::before { content: "" !important; position: absolute !important; top: 0 !important; left: 0 !important; bottom: 0 !important; width: 4px !important; background: var(--task-accent) !important; }
        .wf-review-modal .rt-header-shell { display: flex !important; flex-direction: column !important; gap: 12px !important; width: 100% !important; }
        .wf-review-modal .rt-header-top { display: flex !important; justify-content: space-between !important; align-items: flex-start !important; gap: 18px !important; width: 100% !important; }
        .wf-review-modal .rt-header-main { display: flex !important; align-items: center !important; gap: 14px !important; min-width: 0 !important; flex: 1 1 auto !important; }
        .wf-review-modal .rt-header-copy { display: flex !important; flex-direction: column !important; gap: 4px !important; min-width: 0 !important; padding-top: 2px !important; }
        .wf-review-modal .rt-modal-title { display: inline-flex !important; align-items: center !important; margin: 0 !important; color: #0f172a !important; font-size: 18px !important; font-weight: 850 !important; line-height: 1.2 !important; min-width: 0 !important; }
        .wf-review-modal .rt-header-icon { width: 48px !important; height: 48px !important; min-height: 48px !important; border-radius: 10px !important; display: inline-flex !important; align-items: center !important; justify-content: center !important; color: var(--task-accent) !important; background: #ffffff !important; border: 1px solid var(--task-accent) !important; box-shadow: 0 8px 18px -12px rgba(15,23,42,0.28) !important; font-size: 18px !important; flex-shrink: 0 !important; }
        .wf-review-modal .rt-modal-title-text { display: inline-flex !important; align-items: center !important; gap: 10px !important; min-width: 0 !important; flex-wrap: wrap !important; }
        .wf-review-modal .rt-modal-title-badge { display: inline-flex !important; align-items: center !important; justify-content: center !important; padding: 4px 10px !important; border-radius: 999px !important; font-size: 10px !important; font-weight: 800 !important; text-transform: uppercase !important; letter-spacing: 0.02em !important; background: #eff6ff !important; color: var(--task-accent) !important; border: 1px solid rgba(37, 99, 235, 0.1) !important; }
        .wf-review-modal .rt-modal-desc { display: inline-flex !important; align-items: center !important; gap: 6px !important; color: #64748b !important; font-weight: 500 !important; line-height: 1.4 !important; font-size: 12px !important; }
        .wf-review-modal .rt-modal-desc i { color: var(--task-accent) !important; }
        .wf-review-modal .rt-action-btn { display: inline-flex !important; align-items: center !important; justify-content: center !important; width: 36px !important; height: 36px !important; padding: 0 !important; font-size: 12px !important; font-weight: 700 !important; color: #64748b !important; background: #ffffff !important; border: 1px solid #cbd5e1 !important; border-radius: 8px !important; cursor: pointer !important; transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important; box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05) !important; outline: none !important; }
        .wf-review-modal .rt-action-btn:hover { color: #0f172a !important; border-color: #94a3b8 !important; background: #f8fafc !important; transform: translateY(-1px) !important; box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important; }
        .wf-review-modal .rt-action-btn i { font-size: 11px !important; color: #94a3b8 !important; }
        .wf-review-modal .rt-action-btn:hover i { color: #ef4444 !important; }
        .wf-review-modal .modal-body { padding: 28px !important; background: #ffffff !important; }
        .wf-review-modal .form-group { margin-bottom: 20px !important; }
        .wf-review-modal label { display: block !important; font-size: 12.5px !important; font-weight: 800 !important; color: #1e3a8a !important; margin-bottom: 8px !important; text-transform: uppercase !important; letter-spacing: 0.05em !important; }
        .wf-review-modal .form-control { background: #ffffff !important; border: 1.5px solid #cbd5e1 !important; border-radius: 10px !important; padding: 10px 14px !important; font-size: 14px !important; font-weight: 600 !important; color: #1e293b !important; transition: all 0.2s ease !important; box-shadow: inset 0 2px 4px rgba(15, 23, 42, 0.02) !important; outline: none !important; }
        .wf-review-modal .form-control:focus { border-color: #2563eb !important; box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12), inset 0 2px 4px rgba(15, 23, 42, 0.02) !important; }
        .wf-review-modal textarea.form-control { min-height: 80px !important; resize: vertical !important; }
        .wf-review-modal .wf-section-label { font-size: 12.5px !important; font-weight: 800 !important; color: #1e3a8a !important; letter-spacing: 0.08em !important; text-transform: uppercase !important; margin-bottom: 12px !important; display: block !important; }
        .wf-review-modal .wf-status-cards-group { display: flex !important; gap: 16px !important; width: 100% !important; margin-bottom: 24px !important; }
        .wf-review-modal .wf-status-card-wrap { flex: 1 !important; }
        .wf-review-modal .wf-status-radio-input { display: none !important; }
        .wf-review-modal .wf-status-card { display: flex !important; align-items: center !important; gap: 16px !important; padding: 16px 20px !important; border-radius: 16px !important; border: 2px solid #e2e8f0 !important; background: #ffffff !important; cursor: pointer !important; transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important; margin-bottom: 0 !important; user-select: none !important; width: 100% !important; }
        .wf-review-modal .wf-status-card:hover { border-color: #cbd5e1 !important; background: #f8fafc !important; transform: translateY(-1px) !important; }
        .wf-review-modal .wf-status-card-icon { font-size: 24px !important; display: inline-flex !important; align-items: center !important; justify-content: center !important; }
        .wf-review-modal .wf-status-card-text { display: flex !important; flex-direction: column !important; gap: 2px !important; }
        .wf-review-modal .wf-status-card-title { font-size: 15px !important; font-weight: 800 !important; color: #0f172a !important; }
        .wf-review-modal .wf-status-card-desc { font-size: 12px !important; color: #64748b !important; font-weight: 500 !important; }
        .wf-review-modal .approved-card .wf-status-card-icon { color: #10b981 !important; }
        .wf-review-modal .wf-status-radio-input:checked + .approved-card { border-color: #10b981 !important; background: rgba(16, 185, 129, 0.06) !important; box-shadow: 0 4px 12px rgba(16, 185, 129, 0.08) !important; }
        .wf-review-modal .rejected-card .wf-status-card-icon { color: #ef4444 !important; }
        .wf-review-modal .wf-status-radio-input:checked + .rejected-card { border-color: #ef4444 !important; background: rgba(239, 68, 68, 0.06) !important; box-shadow: 0 4px 12px rgba(239, 68, 68, 0.08) !important; }
        .wf-review-modal .wf-or-divider { display: flex !important; align-items: center !important; justify-content: center !important; height: 100% !important; padding-top: 24px !important; }
        .wf-review-modal .wf-or-badge { padding: 6px 12px !important; background: #f1f5f9 !important; color: #64748b !important; border-radius: 999px !important; font-size: 11px !important; font-weight: 800 !important; letter-spacing: 0.05em !important; border: 1px solid #e2e8f0 !important; }
        .wf-review-modal input[name="adjustmentPlus"],
        .wf-review-modal input[name="adjustmentMinues"] {
          padding-left: 36px !important;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%2364748b'%3E%3Cpath d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V19h-2.82v-.91c-1.39-.33-2.58-1.22-2.83-2.59h1.79c.21.64.76 1.09 1.48 1.15V13.8c-1.63-.44-2.82-1.32-2.82-3.1 0-1.61 1.09-2.68 2.38-2.97V7h2.82v.91c1.24.26 2.11 1.02 2.37 2.13h-1.8c-.18-.54-.62-.9-1.23-.96v2.79c1.69.49 2.82 1.34 2.82 3.19 0 1.64-1.07 2.76-2.4 3.03z'/%3E%3C/svg%3E") !important;
          background-repeat: no-repeat !important;
          background-position: 12px center !important;
          background-size: 16px 16px !important;
        }

        .wf-review-modal .wf-final-amount-value-card {
          height: 44px !important;
          display: flex !important;
          align-items: center !important;
          padding: 10px 14px 10px 36px !important;
          font-size: 14px !important;
          font-weight: 700 !important;
          border-radius: 10px !important;
          outline: none !important;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%2315803d'%3E%3Cpath d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V19h-2.82v-.91c-1.39-.33-2.58-1.22-2.83-2.59h1.79c.21.64.76 1.09 1.48 1.15V13.8c-1.63-.44-2.82-1.32-2.82-3.1 0-1.61 1.09-2.68 2.38-2.97V7h2.82v.91c1.24.26 2.11 1.02 2.37 2.13h-1.8c-.18-.54-.62-.9-1.23-.96v2.79c1.69.49 2.82 1.34 2.82 3.19 0 1.64-1.07 2.76-2.4 3.03z'/%3E%3C/svg%3E") !important;
          background-repeat: no-repeat !important;
          background-position: 12px center !important;
          background-size: 16px 16px !important;
          background-color: #f0fdf4 !important;
          border: 1.5px solid #bbf7d0 !important;
          color: #15803d !important;
          box-shadow: inset 0 2px 4px rgba(15, 23, 42, 0.02) !important;
          margin-top: 10px !important;
        }
        .wf-review-modal .modal-footer { background: #f8fafc !important; border-top: 1px solid #edf2f7 !important; padding: 16px 24px !important; display: flex !important; justify-content: flex-end !important; gap: 12px !important; }
        .wf-review-modal .wf-modal-footer-close-btn { display: inline-flex !important; align-items: center !important; gap: 7px !important; padding: 9px 20px !important; font-size: 13px !important; font-weight: 700 !important; color: #475569 !important; background: #ffffff !important; border: 1px solid #cbd5e1 !important; border-radius: 8px !important; cursor: pointer !important; transition: all 0.2s ease !important; outline: none !important; }
        .wf-review-modal .wf-modal-footer-close-btn:hover { background: #f8fafc !important; color: #0f172a !important; }
        .wf-review-modal .wf-btn-save { display: inline-flex !important; align-items: center !important; justify-content: center !important; gap: 8px !important; height: 38px !important; padding: 0 24px !important; border-radius: 8px !important; border: 1px solid rgba(37, 99, 235, 0.15) !important; background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%) !important; color: #ffffff !important; font-size: 13.5px !important; font-weight: 700 !important; cursor: pointer !important; transition: all 0.2s ease !important; outline: none !important; box-shadow: 0 4px 12px rgba(37, 99, 235, 0.15) !important; }
        .wf-review-modal .wf-btn-save:hover { background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%) !important; transform: translateY(-1px) !important; box-shadow: 0 6px 16px rgba(37, 99, 235, 0.2) !important; }
        .wf-review-modal .wf-btn-save:active { transform: scale(0.97) !important; }
      `,
        }}
      />

      <Modal
        show={invRevShowHide}
        size="xl"
        dialogClassName="wf-review-modal"
        centered
      >
        <Modal.Header>
          <div className="rt-header-shell">
            <div className="rt-header-top">
              <div className="rt-header-main">
                <i
                  className="rt-header-icon fa fa-check-square-o"
                  aria-hidden="true"
                />
                <div className="rt-header-copy">
                  <h2 className="rt-modal-title">
                    <span className="rt-modal-title-text">
                      <span>Time Log Review</span>
                      <span className="rt-modal-title-badge">Review</span>
                    </span>
                  </h2>
                  <span className="rt-modal-desc">
                    <i className="fa fa-info-circle" aria-hidden="true" />{" "}
                    Review timelogs, make adjustments, and approve/reject
                    transactions.
                  </span>
                </div>
              </div>
              <button
                type="button"
                className="rt-action-btn"
                onClick={() => handleInvRevShowHide("", "")}
                title="Close"
              >
                <i className="fa fa-times" aria-hidden="true" />
              </button>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body className="border-0">
          <div className="row">
            <div className="col-md-12">
              <span className="wf-section-label">Review Status</span>
              <div className="wf-status-cards-group">
                <div className="wf-status-card-wrap">
                  <input
                    name="status"
                    className="wf-status-radio-input"
                    id="approved"
                    type="radio"
                    value="true"
                    onChange={handleChange}
                    checked={
                      data["status"] === true || data["status"] === "true"
                    }
                  />
                  <label
                    className="wf-status-card approved-card"
                    htmlFor="approved"
                  >
                    <div className="wf-status-card-icon">
                      <i className="fa fa-check-circle"></i>
                    </div>
                    <div className="wf-status-card-text">
                      <span className="wf-status-card-title">Approve</span>
                      <span className="wf-status-card-desc">
                        Accept timelog and finalize payment
                      </span>
                    </div>
                  </label>
                </div>
                <div className="wf-status-card-wrap">
                  <input
                    name="status"
                    className="wf-status-radio-input"
                    id="notApproved"
                    type="radio"
                    value="false"
                    onChange={handleChange}
                    checked={
                      data["status"] === false || data["status"] === "false"
                    }
                  />
                  <label
                    className="wf-status-card rejected-card"
                    htmlFor="notApproved"
                  >
                    <div className="wf-status-card-icon">
                      <i className="fa fa-times-circle"></i>
                    </div>
                    <div className="wf-status-card-text">
                      <span className="wf-status-card-title">Reject</span>
                      <span className="wf-status-card-desc">
                        Flag issues or reject this invoice
                      </span>
                    </div>
                  </label>
                </div>
              </div>
            </div>
            <div className="col-md-5">
              {renderInput("adjustmentPlus", "Adjustment Plus ($)")}
            </div>
            <div className="col-md-2">
              <div className="wf-or-divider">
                <span className="wf-or-badge">OR</span>
              </div>
            </div>
            <div className="col-md-5">
              {renderInput("adjustmentMinues", "Adjustment Minus ($)")}
            </div>
            <div className="col-md-12 form-group">
              <label className="form-control-label">
                Final Amount to Pay ($)
              </label>
              <div className="wf-final-amount-value-card">
                {data.finalAmt || "0.00"}
              </div>
            </div>
            <div className="col-md-12">
              {renderTextArea("reason", "Reason")}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="wf-modal-footer-close-btn"
            onClick={() => handleInvRevShowHide("", "")}
          >
            <i className="fa fa-times" aria-hidden="true"></i> Close
          </button>
          <button className="wf-btn-save" onClick={handleSubmit} disabled={isProcessing}>
            <i className={`fa ${isProcessing ? "fa-spinner fa-spin" : "fa-check"}`} aria-hidden="true"></i>{" "}
            {isProcessing ? "Saving..." : "Save"}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default InvoiceReview;
